import defaultLinks from '@/locales/pt_BR/links';

const links = {
  ...defaultLinks,
  host: 'https://www.clicksign.com/en',
};

export default links;
